import { Gondor } from "../Gondor";

const ACTIONS = {
  DEDICATED_TIME: "/dedicatedTime/",
  DEDICATED_TIME_ITEM: "/dedicatedTime/{id}/",
  ADD_SYSTEMS: "/dedicatedTime/add/system",
  REMOVE_SYSTEMS: "/dedicatedTime/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.DEDICATED_TIME, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.DEDICATED_TIME_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.DEDICATED_TIME, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(
    ACTIONS.DEDICATED_TIME_ITEM.replace("{id}", id),
    body
  );
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.DEDICATED_TIME_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
